// extracted by mini-css-extract-plugin
module.exports = {"container":"EditBurnRate_container__3yZeR","field":"EditBurnRate_field__2tQB0","submit":"EditBurnRate_submit__OXlHa"};